import { isEqual } from 'lodash';
import { useRef } from 'react';

/**
 * A hook that stores the previous value of an object and only updates it if the new value is different
 * from the previous value, using a deep comparison by default or the supplied comparison.
 */
export function useDeepCompareWithRef<T>(value: T, compare: (previous: T | undefined, next: T) => boolean = isEqual) {
  const ref = useRef<T>(undefined);
  if (!compare(ref.current, value)) {
    ref.current = value; //ref.current contains the previous object value
  }

  return ref.current;
}
